import {combineReducers} from 'redux'
import messenger from '../../account/app/reducers/messenger'
import app from './reducers/app'

const rootReducer = combineReducers({
  app,
  messenger
})

export default rootReducer
